import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="relative" style={{ backgroundColor: "var(--navy)", color: "var(--cream)" }} data-testid="footer">
    <div className="noise" />
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 relative">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo.png" alt="logo" className="h-16 w-16 object-contain" />
            <span className="font-display text-3xl">Mimi &amp; Me Swimming</span>
          </div>
          <p className="font-body font-light max-w-md leading-relaxed" style={{ color: "var(--powder)" }}>
            Personalized private swim instruction for babies, toddlers and children — taught in
            your own home pool across Boca Raton and Palm Beach County, Florida.
          </p>
          <p className="font-display italic text-2xl mt-6" style={{ color: "var(--gold)" }}>
            Confidence • Safety • Skills for Life
          </p>
        </div>

        <div>
          <h4 className="overline mb-5" style={{ color: "var(--gold)" }}>Explore</h4>
          <ul className="space-y-3 font-body font-light text-sm">
            {[["About Milly", "/about"], ["Private Lessons", "/lessons"], ["Breakthrough Intensive", "/intensive"], ["Gallery", "/gallery"], ["FAQ", "/faq"]].map(([l, to]) => (
              <li key={to}><Link to={to} className="hover:text-[var(--gold)] transition-colors" style={{ color: "var(--powder)" }}>{l}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="overline mb-5" style={{ color: "var(--gold)" }}>Connect</h4>
          <ul className="space-y-4 font-body font-light text-sm">
            <li><a href="tel:5615776346" className="flex items-center gap-3 hover:text-[var(--gold)] transition-colors" style={{ color: "var(--powder)" }} data-testid="footer-phone"><Phone size={16} /> 561-577-6346</a></li>
            <li><a href="https://instagram.com/mila_pilar444" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--gold)] transition-colors" style={{ color: "var(--powder)" }} data-testid="footer-instagram"><Instagram size={16} /> @mila_pilar444</a></li>
            <li className="flex items-center gap-3" style={{ color: "var(--powder)" }}><MapPin size={16} /> Boca Raton &amp; Palm Beach, FL</li>
          </ul>
          <Link to="/contact" className="btn-secondary mt-8 !border-[var(--gold)] !text-[var(--cream)] !py-3 !px-6">Request Availability</Link>
        </div>
      </div>

      <div className="hairline my-12" />
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-body" style={{ color: "var(--powder)" }}>
        <span>© {new Date().getFullYear()} Mimi &amp; Me Swimming. All rights reserved.</span>
        <span>A personalized private-swim experience — not a one-size-fits-all program.</span>
      </div>
    </div>
  </footer>
);
